module.exports = __webpack_public_path__ + "img/xxcy.08ebc6aa.png";